import {AxiosInstance, AxiosRequestConfig} from 'axios'

export interface DeliveryAnnotationDataScope {
  orgUnitId?: string
  customerId?: string
  siteId?: string
  countryId?: string
  businessLine?: string
}

export interface DeliveryAnnotationAudit {
  createdByUserId: string
  createdByUserName: string
  createdByEmail: string
  createdAt: string
  updatedByUserId?: string | null
  updatedByUserName?: string | null
  updatedByEmail?: string | null
  updatedAt?: string | null
}

export interface DeliveryAnnotation {
  id: string
  entityType: 'Delivery' | 'Order'
  entityId: string
  parentEntityType?: 'Delivery' | 'Order' | null
  parentEntityId?: string | null
  content: string
  dataScope: DeliveryAnnotationDataScope
  audit: DeliveryAnnotationAudit
}

export interface CreateDeliveryAnnotationRequest {
  entityType: 'Delivery' | 'Order'
  entityId: string
  parentEntityType?: 'Delivery' | 'Order'
  parentEntityId?: string
  content: string
  countryId: string
  orgUnitId: string
  customerId: string
  businessLine: string
  siteId?: string
}

export interface UpdateDeliveryAnnotationRequest {
  content: string
}

export interface QueryDeliveryAnnotationsParams {
  entityType: 'Delivery' | 'Order'
  entityId?: string
  parentEntityType?: 'Delivery' | 'Order'
  parentEntityId?: string
  orgUnitId?: string
  customerId?: string
  siteId?: string
  countryId?: string
  businessLine?: string
}

// API defined endpoints
export const createDeliveryAnnotation =
  (api: AxiosInstance) =>
  async (
    request: CreateDeliveryAnnotationRequest,
    axiosConfig?: AxiosRequestConfig
  ): Promise<DeliveryAnnotation> => {
    const response = await api.post<DeliveryAnnotation>('/customernotes', request, axiosConfig)
    return response.data
  }

export const getDeliveryAnnotation =
  (api: AxiosInstance) =>
  async (id: string, axiosConfig?: AxiosRequestConfig): Promise<DeliveryAnnotation> => {
    const response = await api.get<DeliveryAnnotation>(`/customernotes/${id}`, axiosConfig)
    return response.data
  }

export const queryDeliveryAnnotations =
  (api: AxiosInstance) =>
  async (
    params: QueryDeliveryAnnotationsParams,
    axiosConfig?: AxiosRequestConfig
  ): Promise<DeliveryAnnotation[]> => {
    const config = {params, ...axiosConfig}
    const response = await api.get<DeliveryAnnotation[]>('/customernotes', config)
    return response.data
  }

export const updateDeliveryAnnotation =
  (api: AxiosInstance) =>
  async (
    id: string,
    request: UpdateDeliveryAnnotationRequest,
    axiosConfig?: AxiosRequestConfig
  ): Promise<DeliveryAnnotation> => {
    const response = await api.patch<DeliveryAnnotation>(`/customernotes/${id}`, request, axiosConfig)
    return response.data
  }

export const deleteDeliveryAnnotation =
  (api: AxiosInstance) =>
  async (id: string, axiosConfig?: AxiosRequestConfig): Promise<void> => {
    await api.delete(`/customernotes/${id}`, axiosConfig)
  }
